'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactUtils = require('react-utils');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _components = require('I18n/components');

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _color = require('MeetingsBase/utils/color');

var _BookingFormField = require('MeetingsLib/components/input/BookingFormField');

var _BookingFormField2 = _interopRequireDefault(_BookingFormField);

var _EmailAddress = require('PatternValidationJS/patterns/EmailAddress');

var _EmailAddress2 = _interopRequireDefault(_EmailAddress);

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _BookActions = require('MeetingsLib/redux/actions/BookActions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailForm = _react2.default.createClass({
  displayName: 'EmailForm',

  propTypes: {
    compact: _react.PropTypes.bool,
    setFormValue: _react.PropTypes.func.isRequired,
    fetchPublicAvailabilityInfoForOwner: _react.PropTypes.func.isRequired,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    markShowedEmailForm: _react.PropTypes.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      email: ''
    };
  },
  getEmailIsValid: function getEmailIsValid() {
    var email = this.state.email;


    return Boolean(email && _EmailAddress2.default.test(email));
  },
  onEmailChange: function onEmailChange(fieldName, email) {
    this.setState({ email: email });
  },
  getValidation: function getValidation() {
    if (this.getEmailIsValid()) {
      return false;
    }
    return _I18n2.default.text('prebook.details.errorHelper.email');
  },
  getClassNames: function getClassNames() {
    return (0, _reactUtils.classNames)('email-form height-100 p-all-5', {
      compact: this.props.compact
    });
  },
  handleEmailSubmit: function handleEmailSubmit(e) {
    e.preventDefault();

    var email = this.state.email;
    var _props = this.props,
        setFormValue = _props.setFormValue,
        fetchPublicAvailabilityInfoForOwner = _props.fetchPublicAvailabilityInfoForOwner,
        markShowedEmailForm = _props.markShowedEmailForm;

    setFormValue('email', email);
    fetchPublicAvailabilityInfoForOwner({ email: email }).then(markShowedEmailForm);
  },
  renderButton: function renderButton() {
    var primaryColor = this.props.branding.primaryColor;


    var color = (0, _color.getPrimaryColorOrDefault)(primaryColor);
    var isValid = this.getEmailIsValid();

    return _react2.default.createElement(
      'div',
      { className: 'text-center m-top-5' },
      _react2.default.createElement(
        _UIButton2.default,
        {
          style: { borderColor: color, backgroundColor: color },
          use: 'primary',
          disabled: !isValid,
          onClick: this.handleEmailSubmit,
          size: 'medium'
        },
        _react2.default.createElement(_components.FormattedMessage, { message: 'emailForm.button' })
      )
    );
  },
  render: function render() {
    var classes = this.getClassNames();
    var fieldLabel = _I18n2.default.text('emailForm.placeholder');

    return _react2.default.createElement(
      _UIFlex2.default,
      { justify: 'around', className: classes },
      _react2.default.createElement(
        'div',
        { style: { maxWidth: '350px' } },
        _react2.default.createElement(
          'div',
          { className: 'text-center m-top-4' },
          _react2.default.createElement(_UIIllustration2.default, { name: 'meetings', width: '60%' }),
          _react2.default.createElement(
            'h1',
            { className: 'm-y-2' },
            _react2.default.createElement(_components.FormattedMessage, { message: 'emailForm.header' })
          ),
          _react2.default.createElement(
            'p',
            { className: 'm-bottom-4' },
            _react2.default.createElement(_components.FormattedMessage, { message: 'emailForm.text' })
          )
        ),
        _react2.default.createElement(_BookingFormField2.default, {
          fieldName: 'email',
          fieldLabel: fieldLabel,
          validation: this.getValidation(),
          fieldValue: this.state.email,
          isRequired: true,
          setFormValue: this.onEmailChange,
          autocomplete: 'on'
        }),
        this.renderButton()
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(function () {
  return {};
}, _extends({}, FormActions, {
  fetchPublicAvailabilityInfoForOwner: _BookActions.fetchPublicAvailabilityInfoForOwner
}))(EmailForm);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/sections/EmailForm.js
// module id = 200
// module chunks = 0